import './PrivacyPolicy.css';

export function PrivacyPolicy() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <div className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">Golden 777</p>
          <p className="effective-date">Effective Date: March 1, 2026</p>
        </div>

        <div className="privacy-intro">
          <p>
            At Golden777, accessible from golden777.fun and our mobile application Golden777, one of our main
            priorities is the privacy of our visitors. This Privacy Policy document contains types of information
            that is collected and recorded by Golden777 and how we use it.
          </p>
        </div>

        <section className="privacy-section">
          <h2 className="privacy-heading">1. Information We Collect</h2>
          <p>
            We collect several different types of information for various purposes to provide and improve our
            service to you.
          </p>

          <h3 className="privacy-subheading">Personal Data</h3>
          <p>
            While using our App or Website, we may ask you to provide us with certain personally identifiable
            information that can be used to contact or identify you, including:
          </p>
          <ul className="privacy-list">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Username and Social Media profile data (if linking via Facebook/Google)</li>
            <li>Usage Data and device identifiers</li>
          </ul>

          <h3 className="privacy-subheading">Log Files</h3>
          <p>
            Golden777 follows a standard procedure of using log files. These files log visitors when they use the
            app. The information collected includes internet protocol (IP) addresses, browser type, Internet
            Service Provider (ISP), date and time stamp, and referring/exit pages.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">2. How We Use Your Information</h2>
          <p>We use the information we collect in various ways, including to:</p>
          <ul className="privacy-list">
            <li>Provide, operate, and maintain our game and website.</li>
            <li>Improve, personalize, and expand our game features.</li>
            <li>Understand and analyze how you use Golden777.</li>
            <li>Develop new products, services, features, and functionality.</li>
            <li>Communicate with you, either directly or through one of our partners, for customer service or updates.</li>
            <li>Prevent fraud and ensure the security of our gaming environment.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">3. Cookies and Web Beacons</h2>
          <p>
            Like any other website, golden777.fun uses 'cookies'. These cookies are used to store information
            including visitors' preferences, and the pages on the website that the visitor accessed or visited.
            The information is used to optimize the users' experience by customizing our web page content based
            on visitors' browser type and/or other information.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">4. Third-Party Privacy Policies</h2>
          <p>
            Golden777's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising
            you to consult the respective Privacy Policies of these third-party ad servers for more detailed
            information. It may include their practices and instructions about how to opt-out of certain options.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">5. Data Security</h2>
          <p>
            The security of your data is important to us, but remember that no method of transmission over the
            Internet, or method of electronic storage, is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">6. Children's Information</h2>
          <p>
            Another part of our priority is adding protection for children while using the internet. Golden777
            does not knowingly collect any Personal Identifiable Information from children under the age of 18.
            If you think that your child provided this kind of information on our platform, we strongly
            encourage you to contact us immediately and we will do our best efforts to promptly remove such
            information from our records.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">7. Consent</h2>
          <p>
            By using our website or app, you hereby consent to our Privacy Policy and agree to its Terms and
            Conditions.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">8. Contact Us</h2>
          <p>
            If you have additional questions or require more information about our Privacy Policy, do not hesitate
            to contact us at:
          </p>
          <div className="contact-info">
            <p>
              <strong>Email:</strong> <a href="mailto:support@golden777.fun">support@golden777.fun</a>
            </p>
            <p>
              <strong>Website:</strong> <a href="https://golden777.fun/support">golden777.fun/support</a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
